var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgKaddexLogoLightMode = function SvgKaddexLogoLightMode(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 24,
    viewBox: "0 0 158 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-kaddex-light-mode",
    x1: 0.551,
    y1: 0.499,
    x2: 1.089,
    y2: 0.485,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076c95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-kaddex-light-mode-2",
    x1: 0.1,
    y1: -0.1,
    x2: 1.087,
    y2: 0.869,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#bc0050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.192,
    stopColor: "#a02469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#7b578b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#5a84a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#3eaac3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#27c9d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#16e0e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#09f1f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#02fbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00fffd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_73720",
    "data-name": "Group 73720",
    transform: "translate(1517.993 -2306.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_66929",
    "data-name": "Path 66929",
    d: "M-1517.993,2310h2.458a.206.206,0,0,1,.206.206v23.39a.206.206,0,0,1-.206.206h-2.458",
    transform: "translate(0 -3.359)",
    fill: "#292a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_66930",
    "data-name": "Path 66930",
    d: "M-1429.593,2320.656h3.369a.48.48,0,0,0,.332-.133l10.547-10.1a.481.481,0,0,1,.332-.133h3.822a.206.206,0,0,1,.142.354l-11.7,11.2a.48.48,0,0,0,0,.694l11.7,11.2a.206.206,0,0,1-.142.354h-3.822a.48.48,0,0,1-.332-.134l-10.48-10.046a.48.48,0,0,0-.332-.134h-3.71a.206.206,0,0,1-.206-.206v-2.439A.48.48,0,0,1-1429.593,2320.656Z",
    transform: "translate(-83.373 -3.633)",
    fill: "#292a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_42610",
    "data-name": "Path 42610",
    d: "M-463.647,2333.866h-11.417a.48.48,0,0,1-.48-.48V2317.83a.48.48,0,0,1,.48-.48h2.443a.206.206,0,0,1,.206.206v12.959a.206.206,0,0,0,.206.206h8.568a8.437,8.437,0,0,0,4.395-1.184,9.024,9.024,0,0,0,3.19-3.166,8.423,8.423,0,0,0,1.189-4.406,8.484,8.484,0,0,0-1.189-4.406,9.014,9.014,0,0,0-3.19-3.186,8.471,8.471,0,0,0-4.395-1.179h-11.692a.206.206,0,0,1-.206-.206v-2.444a.48.48,0,0,1,.48-.48h11.417a11.4,11.4,0,0,1,5.967,1.613,12.3,12.3,0,0,1,4.318,4.319,11.436,11.436,0,0,1,1.618,5.968,11.434,11.434,0,0,1-1.618,5.978,12.337,12.337,0,0,1-4.318,4.309A11.416,11.416,0,0,1-463.647,2333.866Z",
    transform: "translate(-988.53 -3.415)",
    fill: "#292a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_42611",
    "data-name": "Path 42611",
    d: "M61.919,2333.866H50.5a.48.48,0,0,1-.48-.48V2317.83a.48.48,0,0,1,.48-.48h2.443a.206.206,0,0,1,.206.206v12.959a.206.206,0,0,0,.206.206h8.568a8.437,8.437,0,0,0,4.395-1.184,9.031,9.031,0,0,0,3.185-3.166,8.757,8.757,0,0,0,0-8.812,9.007,9.007,0,0,0-3.185-3.186,8.471,8.471,0,0,0-4.395-1.179h-11.7a.206.206,0,0,1-.206-.206v-2.444a.48.48,0,0,1,.48-.48H61.919a11.4,11.4,0,0,1,5.967,1.613,12.3,12.3,0,0,1,4.318,4.319,11.834,11.834,0,0,1,0,11.946,12.336,12.336,0,0,1-4.318,4.309A11.426,11.426,0,0,1,61.919,2333.866Z",
    transform: "translate(-1486.912 -3.415)",
    fill: "#292a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_42612",
    "data-name": "Path 42612",
    d: "M576.066,2310h22.84a.48.48,0,0,1,.48.48v2.443a.206.206,0,0,1-.206.206h-20.26a.206.206,0,0,0-.206.206v6.823a.206.206,0,0,0,.206.206h9.349a.48.48,0,0,1,.48.48v2.444a.206.206,0,0,1-.206.206H576.071a.48.48,0,0,1-.48-.48l0-12.533A.48.48,0,0,1,576.066,2310Zm2.648,16.15v4.306a.206.206,0,0,0,.206.206h19.985a.48.48,0,0,1,.48.48v2.458a.206.206,0,0,1-.206.206H576.066a.48.48,0,0,1-.48-.48v-6.9a.48.48,0,0,1,.48-.48h2.443A.206.206,0,0,1,578.715,2326.153Z",
    transform: "translate(-1985.292 -3.359)",
    fill: "#292a45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_42613",
    "data-name": "Path 42613",
    d: "M1088.458,2333.81h-2.975a.48.48,0,0,1-.366-.792l9.27-10.9a.48.48,0,0,0,0-.622l-9.1-10.7a.48.48,0,0,1,.366-.792h2.974a.206.206,0,0,1,.157.073l13.53,15.938q2.726,3.194,5.934,7a.48.48,0,0,1-.367.79h-2.955a.207.207,0,0,1-.157-.073l-7.912-9.33a.206.206,0,0,0-.314,0l-7.933,9.332A.206.206,0,0,1,1088.458,2333.81Zm11.06-13.3-1.625-1.943a.48.48,0,0,1,0-.619l6.689-7.874a.206.206,0,0,1,.157-.073h2.976a.48.48,0,0,1,.366.791l-8.25,9.718A.206.206,0,0,1,1099.518,2320.511Z",
    transform: "translate(-2468.36 -3.359)",
    fill: "#292a45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_73588",
    "data-name": "Group 73588",
    transform: "translate(-1492.569 2306.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_66931",
    "data-name": "Path 66931",
    d: "M-721.506,2713.5",
    transform: "translate(737.278 -2692.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_68654",
    "data-name": "Group 68654",
    transform: "translate(8.567 21.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_68653",
    "data-name": "Group 68653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_41688",
    "data-name": "Path 41688",
    d: "M-847.222,2713.762a.48.48,0,0,0-.43-.267h-12.682a.48.48,0,0,0-.48.48v2.255a.206.206,0,0,0,.206.206H-845.9Z",
    transform: "translate(860.815 -2713.495)",
    fill: "url(#linear-gradient-kaddex-light-mode)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_68657",
    "data-name": "Group 68657",
    transform: "translate(13.395 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_68656",
    "data-name": "Group 68656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_41689",
    "data-name": "Path 41689",
    d: "M-749.772,2306.461l11.7,23.7a.206.206,0,0,1-.184.3h-3.153l-9.217-18.551",
    transform: "translate(751.5 -2306.461)",
    fill: "#00fffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_66932",
    "data-name": "Path 66932",
    d: "M-765.748,2306.461l3.474,7.04-1.772,3.559-3.38-6.8a.481.481,0,0,1,0-.428Z",
    transform: "translate(767.476 -2306.461)",
    fill: "url(#linear-gradient-kaddex-light-mode-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_68660",
    "data-name": "Group 68660",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-kaddex-light-mode_68659",
    "data-name": "Group 68659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-kaddex-light-mode_41690",
    "data-name": "Path 41690",
    d: "M-1014.935,2306.727a.48.48,0,0,1,.43-.266h3.183l-.027.055-1.74,3.494-10.113,20.313a.206.206,0,0,1-.184.114h-2.577a.48.48,0,0,1-.43-.694Z",
    transform: "translate(1026.445 -2306.461)",
    fill: "#ff00b9"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKaddexLogoLightMode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kaddex_logo_light_mode.8bc91272.svg";
export { ForwardRef as ReactComponent };